import { motion } from "framer-motion"
import { ArrowLeft } from "lucide-react"
import { ReactNode, useState } from "react"

import { CreateReportGeneratorPanel } from "@/features/report/creation/CreateReportGeneratorPanel"
import { Button } from "@ui/button"

import { CollectionItem } from "@vertesia/common"

interface ForkProgramOverlayProps {
    collection?: CollectionItem | undefined
    initialCollection?: CollectionItem | undefined
    onClose?: () => void
    children: ReactNode
}

export function ForkProgramOverlay({ children, collection, initialCollection, onClose }: Readonly<ForkProgramOverlayProps>) {
    const [isOpen, setIsOpen] = useState(false)

    const handleClick = (e: React.MouseEvent) => {
        e.preventDefault()
        e.stopPropagation()
        setIsOpen(true)
    }

    const handleOnClose = () => {
        setIsOpen(false)
        onClose?.()
    }

    return (
        <>
            <div onClick={handleClick} className="w-full">
                {children}
            </div>
            {
                isOpen && (
                    <div className="z-50 fixed inset-0 flex justify-end top-0">
                        <motion.div
                            initial={{ x: "100%" }}
                            animate={{ x: 0 }}
                            exit={{ x: "100%" }}
                            transition={{ type: "spring", stiffness: 300, damping: 30 }}
                            className="w-full h-full bg-white shadow-lg p-0 relative"
                        >
                            <CreateReportGeneratorPanel collection={collection} initialCollection={initialCollection}>
                                <Button onClick={handleOnClose}>
                                    <ArrowLeft />
                                    Back to Report {!collection && "list"}
                                </Button>
                            </CreateReportGeneratorPanel>
                        </motion.div>
                    </div>
                )
            }
        </>
    )
}